import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { BankReconGuidModel, CashbookTxnBankStmtLinkContainer, CashbookTxnStmtReconPossibleLinkContainer } from '../../../../../../models/aggregates/erp/index';
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';



@Injectable({
    providedIn: 'root'
})
export class CashbookTxnStmtReconPossibleLinksService extends BaseApiTemplateService<CashbookTxnStmtReconPossibleLinkContainer> {
    
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-stmt-recon-possible-links'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-stmt-recon-possible-links';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txn-stmt-recon-possible-links';
        this.httpClient = http;
    }

    public post_bankrecon_guid(bankReconGuidModel: BankReconGuidModel, apiVisa:ApiVisa)
    {
        let url = apiVisa.api_domain_url + this.endpoint_path;
             
        return this.httpClient.post(url,bankReconGuidModel,this.getHttpHeader(apiVisa));
    }

    public post_match_and_delete_possible_stmt_recon(cashBookTxnStmtReconLinkContainer : CashbookTxnBankStmtLinkContainer, apiVisa:ApiVisa): Observable<BasicApiResponseModel<CashbookTxnBankStmtLinkContainer>>
    {
        let url = apiVisa.api_domain_url + this.endpoint_path + '/match-and-delete-possible-stmt-recon';
             
        //return this.httpClient.post(url,cashBookTxnStmtReconLinkContainer,this.getHttpHeader(apiVisa));
        return this.httpClient.post<BasicApiResponseModel<CashbookTxnBankStmtLinkContainer>>(url,cashBookTxnStmtReconLinkContainer,this.getHttpHeader(apiVisa));
    }
   
    
}

